import React from 'react';
import VideoEmbed from './VideoEmbed';
import { isNotEmpty } from '../../lib/ep';

const PrizeImage = (props) => {
	const prize = props?.prize ?? false;
	
	if(prize === false) return null;

	const image = (isNotEmpty(props, 'image')) ? props.image : ((isNotEmpty(prize, 'full_image')) ? prize.full_image : false);

	if(image !== false) {
		return (
			<div class="img_preview_bg">
				<img class="img" src={image} width="100%" />
			</div>
		)
	}

	const video = (isNotEmpty(props, 'video')) ? props.video : ((isNotEmpty(prize, 'video')) ? prize.video : false);

	if(video !== false) {
		const video_props = props?.video_props ?? {};

		return (
			<div class="img_preview_bg">
				<VideoEmbed
					{...video_props}
					video_url={video}
					video_thumb={props?.video_thumb ?? (prize?.video_thumb ?? null)}
				/>
			</div>
		);
	}

	const bg_preset = prize?.bg_preset ?? 'minimal';

	return (
		<div class="img_preview_bg">
			<div class={`preset_prize_bg preset_${bg_preset}`}>
				{props.children}

				<img class="preset_img" src={`${window.cdn_url}img/prize_bg_presets/${bg_preset}.png`} width="100%" />

				<div class="over_title hb_mainFontWeightRoman">
					<div class="gui_text_align_center">
						<div dangerouslySetInnerHTML={{ __html:(prize.title) ? prize.title.replace(/\n/g, '<br />') : '' }} />
					</div>
				</div>
			</div>
		</div>
	)
}

export default PrizeImage;